import { useTranslation } from 'react-i18next'
import { Title } from '../../Title'
import styles from './SubscriptionsCredits.module.scss'
import React, { useEffect, useState } from 'react'
import instance from '../../../../../../../providers/axios.config'
import Notiflix from 'notiflix'
import Skeleton from '@mui/material/Skeleton'
import { CustomPagination } from '../../../../../../shared-components/pagination/CustomPagination'
import CardSubscriptions from './cardSubscriptions'
import { IUserSubscription, typeResponse } from '../../../../../../../utils/types'

interface IResponseSubscriptions extends typeResponse {
  data:{
    subscriptions: IUserSubscription[]
    pagination: {
      currentPage: number,
      perPage: number,
      totalPages: number
    }
  }
}

export const MyCredits = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingActiveCredits, setLoadingActiveCredits] = useState(false)
  const [myCreditsActive, setMyCreditsActive] = useState<IUserSubscription[]>([])
  const [myCreditsHistory, setMyCreditsHistory] = useState<IUserSubscription[]>([])
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 16,
    totalPages: 1
  })
  const getMyHistorySubscriptions = async (page = 1) => {
    setIsLoading(true)
    try {
      const resHistory = await instance.get(`subscriptions/credits`, {
        params: {
          active: 0,
          limit: 16,
          page
        }
      }) as IResponseSubscriptions
      setMyCreditsHistory(resHistory?.data?.subscriptions || [])
      setPagination({ ...resHistory?.data?.pagination })
      setIsLoading(false)
    } catch (error) {

      // Show error notification
      Notiflix.Report.failure(
        'Error',
        'Failed to fetch data. Please try again later.',
        'OK'
      )
    }
  }

  const getMyActiveSubscriptions = async () => {
    setLoadingActiveCredits(true);
    try {
      const res = await instance.get(`subscriptions/credits`, {
        params: {
          active: 1,
          limit: 16
        }
      }) as IResponseSubscriptions
      setMyCreditsActive(res?.data?.subscriptions || [])
      setLoadingActiveCredits(false);
    } catch (error) {
      // Show error notification
      Notiflix.Report.failure(
        'Error',
        'Failed to fetch data. Please try again later.',
        'OK'
      )
    }
  }
  useEffect(() => {
    getMyActiveSubscriptions();
    getMyHistorySubscriptions()
  }, [])
  const handleChange = (event: any, value: any) => {
    getMyHistorySubscriptions(value);
  }
  const loadingRender = (type: 'active' | 'history' = 'active') => {
    return (
      <div>
        <div className={styles.bold}>
          <Skeleton />
        </div>
        <div>
          <span className={styles.bold}> <Skeleton /></span>{' '}
          <Skeleton />
        </div>
        <div>
          <span className={styles.bold}> <Skeleton /></span>{' '}
          <Skeleton />
        </div>
      </div>
    )
  }
  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <Title title={t('My Credits')} />
      </div>

      <div className={styles.content}>
        <div className={styles.contentContainer}>
          <div className={styles.title}>{t('Active Credits')}</div>
            {isLoadingActiveCredits ? loadingRender() : <>
              {!myCreditsActive?.length 
                ? (
                  <div className={styles.container}>
                    <div className={styles.content}>
                      {t('no_credits_active')}
                    </div>
                  </div>
                )
                : myCreditsActive.map((active: any) => (
                <div key={`active-${active?.id}`}>
                  <CardSubscriptions style={{ backgroundColor: "#338000" , color: '#fff' }} item={{name: active?.name, expiresAt: active?.expiresAt, downloads: active?.credits, used: active?.credits_used}}/>
                </div>
              ))}
            </>}
            <div className={styles.title}>{t('history_credits')}</div>
            {isLoading 
            ? loadingRender() 
            : (
              !myCreditsHistory?.length
              ? (
                <div className={styles.container}>
                  <div className={styles.content}>
                    {t('no_credits_history')}
                  </div>
                </div>
              ) : (
              <div className={styles.contentHistory}>
                {myCreditsHistory.map((active: any) => (
                  <div key={`active-${active?.id}`}>
                    <CardSubscriptions style={{ backgroundColor: "#c3c3c3" }} item={{name: active?.name, expiresAt: active?.expiresAt, downloads: active?.credits, used: active?.credits_used}}/>
                </div>
                ))}
              </div>
            ))
          }
        </div>
        {pagination?.totalPages > 1 && <CustomPagination
          shape='rounded'
          count={pagination?.totalPages}
          page={pagination?.currentPage}
          onChange={(ev: any, newPage: number) => handleChange(ev, newPage)}
          size='large'
          className={styles.pagination}
        />}
    </div>
</div>
)
}
